import { Injectable } from '@angular/core';

const ONE_SECOND_MS = 1000;
const ONE_MINUTE_MS = 60 * ONE_SECOND_MS;
const CACHE_DURATION = 15 * ONE_MINUTE_MS;

@Injectable()
export class SessionStorageCacheService {
  getItem<T = any>(key: string): T | null {
    const cachedData: string | null = sessionStorage.getItem(key);
    const now: number = new Date().getTime();
    if (cachedData) {
      const { expiredAt, data } = JSON.parse(cachedData);
      if (!expiredAt || now < expiredAt) {
        return JSON.parse(data);
      } else {
        sessionStorage.removeItem(key);
      }
    }
    return null;
  }

  setItem<T = any>(key: string, data: T, ttl: number = CACHE_DURATION): void {
    const cacheData = {
      expiredAt: ttl === 0 ? null : Date.now() + ttl,
      data: JSON.stringify(data)
    };
    sessionStorage.setItem(key, JSON.stringify(cacheData));
  }

  clearItemByPrefix(prefix: string): void {
    const keys = Object.keys(sessionStorage).filter((key) => key.startsWith(prefix));
    keys.forEach((key) => sessionStorage.removeItem(key));
  }
}
